import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'istyle_sidebar_collapsed';

@Injectable({ providedIn: 'root' })
export class SidebarStateService {
  private readonly collapsedSubject = new BehaviorSubject<boolean>(localStorage.getItem(STORAGE_KEY) === '1');
  readonly collapsed$ = this.collapsedSubject.asObservable();

  get collapsed(): boolean {
    return this.collapsedSubject.value;
  }

  toggle(): void {
    this.setCollapsed(!this.collapsed);
  }

  setCollapsed(value: boolean): void {
    localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
    this.collapsedSubject.next(value);
  }
}
